import(/* webpackMode: "eager" */ "D:\\DocSpace\\client\\doc_pace_client\\packages\\login\\src\\app\\global-error.tsx");
